module.exports = __webpack_public_path__ + "img/icon-package.21d7d43d.svg";